/**
 * CopyDialogLinkButton (KAN-710)
 *
 * "Скопировать ссылку" in the conversation modal header: copies the current
 * page address with the dialog params (?dialog=<clientId>&estimate=<id>), so
 * the link opens this very conversation. The params are set from the shown
 * dialog, so a linked card opened inside the modal (KAN-639) gets its own link.
 */
import { Link2 } from 'lucide-react'
import { toast } from 'sonner'
import { Button } from '@/components/ui/button'
import { dialogShareUrl } from '@/hooks/useDialogParam'

interface CopyDialogLinkButtonProps {
  clientId: string | null
  estimateId: string | null
}

export function CopyDialogLinkButton({
  clientId,
  estimateId,
}: CopyDialogLinkButtonProps) {
  const copy = async () => {
    const link = dialogShareUrl(window.location.href, clientId, estimateId)
    try {
      await navigator.clipboard.writeText(link)
      toast.success('Ссылка скопирована')
    } catch {
      toast.error('Не удалось скопировать ссылку')
    }
  }

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className="h-7 gap-1.5 px-2 text-xs"
      onClick={() => void copy()}
      data-testid="copy-dialog-link"
    >
      <Link2 className="h-3.5 w-3.5" aria-hidden="true" />
      Скопировать ссылку
    </Button>
  )
}
